module.exports = __webpack_public_path__ + "static/media/Satanic.061f9ad8.png";